import {} from "@mui/material";
import type React from "react";
import type { AdminContractCreatePageProps } from "../model";
import { ContractCreateInProgress } from "./in-progress";
import { ContractCreatePreview } from "./preview";

export const AdminContractCreatePageUi: React.FC<
  AdminContractCreatePageProps
> = (props) => {
  if (props.previewValues) {
    return <ContractCreatePreview {...props} />;
  }
  return <ContractCreateInProgress {...props} />;
};
